/**
 * @generated SignedSource<<e202a9277102f55d0a7c16bbbdc055d0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveUserPushTokenInput = {
  clientMutationId?: string | null | undefined;
  token?: string | null | undefined;
};
export type useRemoveUserPushTokenMutation$variables = {
  input: RemoveUserPushTokenInput;
};
export type useRemoveUserPushTokenMutation$data = {
  readonly removeUserPushToken: {
    readonly user: {
      readonly isPushNotificationsEnabled: boolean | null | undefined;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useRemoveUserPushTokenMutation = {
  response: useRemoveUserPushTokenMutation$data;
  variables: useRemoveUserPushTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPushNotificationsEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRemoveUserPushTokenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveUserPushTokenPayload",
        "kind": "LinkedField",
        "name": "removeUserPushToken",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useRemoveUserPushTokenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveUserPushTokenPayload",
        "kind": "LinkedField",
        "name": "removeUserPushToken",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e9346d1e136e2e31a18d07e7a3cb8dd",
    "id": null,
    "metadata": {},
    "name": "useRemoveUserPushTokenMutation",
    "operationKind": "mutation",
    "text": "mutation useRemoveUserPushTokenMutation(\n  $input: RemoveUserPushTokenInput!\n) {\n  removeUserPushToken(input: $input) {\n    user {\n      isPushNotificationsEnabled\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "342f83b4e4255ddcd5e46fbd6066f33b";

export default node;
